import React from "react";
import {Link} from "@heroui/react";

export default function SiteFooter() {
  return (
    <footer className="bg-default-50/5 border-default-100/40 mt-16 w-full border-t">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-center gap-2 px-6 py-6 text-center text-[11px] leading-relaxed text-default-500 sm:px-8 sm:text-xs">
        <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
          <Link href="https://www.3chatai.com/privacy" target="_blank" className="text-current hover:text-primary/80 text-[11px] sm:text-xs" underline="hover">
            隐私政策
          </Link>
          <span className="text-default-400">·</span>
          <Link href="https://www.3chatai.com/cookie" target="_blank" className="text-current hover:text-primary/80 text-[11px] sm:text-xs" underline="hover">
            Cookie 政策
          </Link>
          <span className="text-default-400">·</span>
          <Link href="https://www.3chatai.com/terms" target="_blank" className="text-current hover:text-primary/80 text-[11px] sm:text-xs" underline="hover">
            服务条款
          </Link>
          <span className="text-default-400">·</span>
          <Link href="https://www.3chatai.com/data-security" target="_blank" className="text-current hover:text-primary/80 text-[11px] sm:text-xs" underline="hover">
            数据安全管理规范
          </Link>
          <span className="text-default-400">·</span>
          <Link href="https://www.3chatai.com/risk-disclaimer" target="_blank" className="text-current hover:text-primary/80 text-[11px] sm:text-xs" underline="hover">
            风险告知与免责声明
          </Link>
        </div>
        <p className="space-y-1">
          <span className="block sm:inline">
            © 2026, 3Chat.ai All rights reserved.
          </span>
          <span className="block sm:inline sm:ml-2">
            上海纽酷信息科技有限公司 沪ICP备18014720号-10 （3chatai.cn） | 沪ICP备18014720号-11 （3chatai.com）
          </span>
        </p>
      </div>
    </footer>
  );
}

